import React from 'react'
import Stack from '@mui/material/Stack'
import Tabs from '../../../shared/components/Tabs/Tabs'
import { TPPInfo } from '../types'
import VersionList from './VersionList'

interface VersionHistoryContentProps {
    tppInfo: TPPInfo
    selectedColumnId: string | null
    onColumnChange: (columnId: string) => void
}

const VersionHistoryContent = ({ tppInfo, selectedColumnId, onColumnChange }: VersionHistoryContentProps) => {
    const effectiveColumnId = selectedColumnId ?? tppInfo.columns[0]?._id ?? ''

    return (
        <Stack flex={1} minHeight={0}>
            <Tabs
                orientation="horizontal"
                selectedTabId={effectiveColumnId}
                onTabChange={(id) => onColumnChange(id)}
                sx={{ minHeight: 0 }}
                tabListSx={{
                    mt: 1,
                    ml: -1.5,
                    '&::before': { display: 'none' },
                    '& .MuiTabs-scrollButtons.Mui-disabled': {
                        width: 0,
                        minWidth: 0,
                        opacity: 0,
                    },
                }}
                tabPanelSx={{ minHeight: 0 }}
                tabs={tppInfo.columns.map((col) => ({
                    id: col._id,
                    label: col.title,
                    view: <VersionList columnId={col._id} tppId={tppInfo.tppId} />,
                }))}
            />
        </Stack>
    )
}

export default VersionHistoryContent
